// third-party
import {FormattedMessage} from 'react-intl';

// assets
import { ControlFilled, UsergroupAddOutlined,UserOutlined } from '@ant-design/icons';
import useAuthContext from 'context/useAuthContext';

// type
import {NavItemType} from 'layout/mantis/types/MenuType';
import { TagFilled } from '@ant-design/icons/lib/icons';


// icons
const icons = {
    controlFilled: ControlFilled,
    usergroupAddOutlined: UsergroupAddOutlined,
    userOutlined: UserOutlined,
    tagFilled: TagFilled,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function HRMenuItems() {
    const {permissions, roles} = useAuthContext();
    let items: NavItemType = {};

    if(permissions) {

        if (permissions.some((el: string) => {
            return (el === 'Manage_Employees' || el === 'Manage_Roles')
        })) {
            items = {
                id: 'group-hr',
                title: 'HR',
                type: 'group',
                icon: icons.usergroupAddOutlined,
                children: []
            };

            if (permissions.some((el: string) => {
                return (el === 'Manage_Employees')
            })) {
                items.children.push({
                    id: 'core-hr-employees',
                    title: 'Employees',
                    type: 'item',
                    url: '/app/hr/employees',
                    icon: icons.userOutlined,
                    breadcrumbs: true
                });
            }

            if (permissions.some((el: string) => {
                return (el === 'Manage_Roles')
            })) {
                items.children.push({
                    id: 'core-hr-roles',
                    title: 'Roles',
                    type: 'item',
                    url: '/app/hr/roles',
                    icon: icons.controlFilled,
                    breadcrumbs: true
                });
            }
        }

    }

    return items;
}
